<div class="bar" *ngIf="type == 'bar'">
  <span>{{ data.value | pricePipe }}</span>
</div>

<div class="pie" *ngIf="type == 'pie'">
  <span>{{ data.label }} </span>
  <span>{{ data.value | pricePipe }}</span>
</div>
